import Login from "../../pages/Auth/Login";
import Dashboard from "../../pages/Dashboard/Dashboard";
import MainDashboard from "../../pages/Dashboard/MainDashboard";
import UserManagment from "../../pages/UserManage/UserManagment";

export const mainRoutes = [
  {
    caption: "MainDashboard",
    linkTo: "/*",
    element: <MainDashboard />,
    authRequired: true,
  },
//   {
//     caption: "UserDashboard",
//     linkTo: "/*",
//     element: <Dashboard />,
//     authRequired: true,
//   },
  {
    caption: "Login",
    linkTo: "/login",
    icon: "",
    element: <Login />,
    authRequired: false,
  },
  // {
  //   caption: "UserManagment",
  //   linkTo: "/users",
  //   icon: "",
  //   element: <UserManagment />,
  //   authRequired: true,
  // },
];
